export default __webpack_public_path__ + "static/media/IMS_Logo.7b8ae46b.png";